import { render, staticRenderFns } from "./LegalMentions.html?vue&type=template&id=d1067008&scoped=true&"
import script from "./LegalMentions.vue?vue&type=script&lang=js&"
export * from "./LegalMentions.vue?vue&type=script&lang=js&"
import style0 from "./LegalMentions.scss?vue&type=style&index=0&id=d1067008&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1067008",
  null
  
)

export default component.exports